<template>
  <div class="bsdwz">
    <!-- ==================== 1、需要解决的视觉问题 ==================== -->
    <p class="bt1">1、需要解决的视觉问题有:</p>
    <!-- InquiryIntention: List<bool> → [0/1] x9 -->
    <div class="sjwt">
      <p>
        <el-checkbox :value="!!form.InquiryIntention[0]" @input="(v) => $set(form.InquiryIntention, 0, v ? true : false)">看远模糊</el-checkbox>
        <span>度数变化;眼健康问题</span>
      </p>
      <p>
        <el-checkbox :value="!!form.InquiryIntention[1]" @input="(v) => $set(form.InquiryIntention, 1, v ? true : false)">看近模糊</el-checkbox>
        <span>双眼视功能异常</span>
      </p>
      <p>
        <el-checkbox :value="!!form.InquiryIntention[2]" @input="(v) => $set(form.InquiryIntention, 2, v ? true : false)">视物变形</el-checkbox>
        <span>散光度数变化;镜片老化变形</span>
      </p>
    </div>
    <div class="sjwt">
      <p>
        <el-checkbox :value="!!form.InquiryIntention[3]" @input="(v) => $set(form.InquiryIntention, 3, v ? true : false)">视物重影</el-checkbox>
        <span>散光原因;双眼视功能异常</span>
      </p>
      <p>
        <el-checkbox :value="!!form.InquiryIntention[4]" @input="(v) => $set(form.InquiryIntention, 4, v ? true : false)">眼睛干涩</el-checkbox>
        <span>干眼问题</span>
      </p>
      <p>
        <el-checkbox :value="!!form.InquiryIntention[5]" @input="(v) => $set(form.InquiryIntention, 5, v ? true : false)">胀疼疲劳</el-checkbox>
        <span>度数未正确矫正;双眼视功能异常;眼压高</span>
      </p>
    </div>
    <div class="sjwt">
      <p>
        <el-checkbox :value="!!form.InquiryIntention[6]" @input="(v) => $set(form.InquiryIntention, 6, v ? true : false)">怕光</el-checkbox>
        <span>屈光不正；弱视；角膜健康问题</span>
      </p>
      <p>
        <el-checkbox :value="!!form.InquiryIntention[7]" @input="(v) => $set(form.InquiryIntention, 7, v ? true : false)">验光配镜</el-checkbox>
      </p>
      <p>
        <el-checkbox :value="!!form.InquiryIntention[8]" @input="(v) => $set(form.InquiryIntention, 8, v ? true : false)">复查管理</el-checkbox>
      </p>
    </div>
    <!-- InquiryIntentionDes: 其它主诉 -->
    <div class="qitsq">
      <p>本次其他主诉需求:</p>
      <input type="text" v-model="form.InquiryIntentionDes">
    </div>

    <!-- ==================== 2、视力/视觉相关 ==================== -->
    <p class="bt1" style="margin-top: 30px;">2、视力/视觉相关:</p>
    <!-- InquiryVisualMonth: string 看不清有多长时间 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.看不清楚有多长时间？</p>
        <p>了解视力下降有多长时间</p>
      </div>
      <div><input type="text" v-model="form.InquiryVisualMonth">月</div>
    </div>
    <!-- InquiryLastEyeCheck: string 最近一次检查时间 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.最近一次检查视力在什么时间?</p>
        <p>了解最近有没有检查过视力，同时看结果有没有参考意义</p>
      </div>
      <div>
        <input type="text" v-model="lastEyeCheckYear" :disabled="noEyeCheck">年
        <input type="text" v-model="lastEyeCheckMonth" :disabled="noEyeCheck">月
        <el-checkbox v-model="noEyeCheck">没有检查过视力</el-checkbox>
      </div>
    </div>
    <!-- InquiryEyeFullCheck: int 0/1 是否做过全面检查 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.是否做过眼轴、角膜曲率、视功能等视觉发育的全面检查?</p>
        <p>是否了解过眼睛生物学参数,知晓视力出现问题的原因</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryEyeFullCheck" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryEyeFullCheck" :label="false">否</el-radio>
      </div>
    </div>
    <!-- InquiryBSDFile: int 0/1 是否有宝视达视力档案 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.是否在宝视达建有视力档案?</p>
        <p>了解有没有建立眼健康档案的意识;是否有历史检查数据做对比</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryBSDFile" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryBSDFile" :label="false">否</el-radio>
      </div>
    </div>
    <!-- InquiryEyeTrain: int 0/1 是否做过视力治疗和训练 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.是否做过视力的相关治疗、保健和视功能训练?</p>
        <p>了解对视力的重视程度;了解对视觉问题的处理是否有正确的认知</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryEyeTrain" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryEyeTrain" :label="false">否</el-radio>
      </div>
    </div>
    <!-- InquiryAtropine: int 0/1 是否使用低浓度阿托品 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.是否使用低浓度的阿托品?</p>
        <p>如果有使用，要关注使用前后眼轴的变化情况</p>
        <p>如果有使用，要关注到对眼睛调节功能的影响</p>
        <p>评估现有的近视防控手段，为接下来的方案做参考</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryAtropine" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryAtropine" :label="false">否</el-radio>
      </div>
    </div>
    <!-- InquiryPEProblem: int 0/1 是否有体育距离感差 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.是否有体育、球类运动距离感差?</p>
        <p>了解视认知和双眼视功能的异常是否影响到运动视觉</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryPEProblem" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryPEProblem" :label="false">否</el-radio>
      </div>
    </div>

    <!-- ==================== 3、旧镜史相关 ==================== -->
    <p class="bt1" style="margin-top: 30px;">3、旧镜史相关:</p>
    <!-- InquiryCorrection: List<int> [0/1] x5 + InquiryOtherCorrection -->
    <div class="slxgbox">
      <div class="slxgbox-a" style="width: 80%;">
        <p>.既往矫正方式:</p>
        <p>根据既往配戴史看配戴效果,为接下来的方案提供参考</p>
        <div style="display: flex;padding-top: 10px;flex-wrap: wrap;">
          <el-checkbox :value="!!form.InquiryCorrection[0]" @input="(v) => $set(form.InquiryCorrection, 0, v ? true : false)">单光眼镜</el-checkbox>
          <el-checkbox :value="!!form.InquiryCorrection[1]" @input="(v) => $set(form.InquiryCorrection, 1, v ? true : false)">框架离焦眼镜</el-checkbox>
          <el-checkbox :value="!!form.InquiryCorrection[2]" @input="(v) => $set(form.InquiryCorrection, 2, v ? true : false)">软性离焦眼镜</el-checkbox>
          <el-checkbox :value="!!form.InquiryCorrection[3]" @input="(v) => $set(form.InquiryCorrection, 3, v ? true : false)">RGP</el-checkbox>
          <el-checkbox :value="!!form.InquiryCorrection[4]" @input="(v) => $set(form.InquiryCorrection, 4, v ? true : false)">OK镜</el-checkbox>
          <span style="padding-left: 10px;">其他</span>
          <input style="width: 100px;padding-left: 10px;" type="text" v-model="form.InquiryOtherCorrection">
        </div>
      </div>
    </div>
    <!-- InquiryFormerLensType: string 现在配戴镜片类型 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <div style="display: flex;">
          <p>.现在配戴的镜片类型:</p>
          <input style="width: 200px;padding-left: 10px;" type="text" v-model="form.InquiryFormerLensType">
        </div>
        <p>了解目前使用的镜片类型</p>
      </div>
    </div>
    <!-- InquiryFormerLensClear: string 配戴清晰度 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.配戴清晰度:</p>
      </div>
      <div>
        <el-radio v-model="form.InquiryFormerLensClear" label="不清">不清</el-radio>
        <el-radio v-model="form.InquiryFormerLensClear" label="良好">良好</el-radio>
      </div>
    </div>
    <!-- InquiryFormerLensComfortable: string 配戴舒适度 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.配戴舒适度:</p>
      </div>
      <div>
        <el-radio v-model="form.InquiryFormerLensComfortable" label="不适">不适</el-radio>
        <el-radio v-model="form.InquiryFormerLensComfortable" label="良好">良好</el-radio>
      </div>
    </div>
    <!-- InquiryFormerLensFrequency: string 是否一直配戴 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.眼镜是否一直配戴:</p>
      </div>
      <div>
        <el-radio v-model="form.InquiryFormerLensFrequency" label="是全天候配戴">是全天候配戴</el-radio>
        <el-radio v-model="form.InquiryFormerLensFrequency" label="需要使用的时候戴，其他时间不戴">需要使用的时候戴，其他时间不戴</el-radio>
      </div>
    </div>
    <!-- InquiryFormerLensStatus: string 现在眼镜情况 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.现在的眼镜情况:</p>
        <p>了解对旧镜矫正视力的影响程度</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryFormerLensStatus" label="变形">变形</el-radio>
        <el-radio v-model="form.InquiryFormerLensStatus" label="磨损">磨损</el-radio>
      </div>
    </div>
    <!-- InquiryChangeGlasses: string 多久更换一次眼镜 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.一般多久更换一次眼镜:</p>
        <p>看是否及时更换眼镜;评估度数变化速度</p>
      </div>
      <div><input type="text" v-model="form.InquiryChangeGlasses">月</div>
    </div>
    <!-- InquiryChangeGlassesDegree: string 每次更换多少度 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.每次更换时一般变化多少度:</p>
        <p>看是否及时更换眼镜;评估度数变化速度</p>
      </div>
      <div><input type="text" v-model="form.InquiryChangeGlassesDegree">度</div>
    </div>
    <!-- InquiryIsFrameGlasses: string 运动时框架是否方便 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.运动时配戴框架眼镜是否方便:</p>
        <p>本次处方方案要考虑配戴方式的影响,如果有,优先考虑接触镜方案</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryIsFrameGlasses" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryIsFrameGlasses" :label="false">否</el-radio>
      </div>
    </div>

    <!-- ==================== 4、用眼和饮食习惯相关 ==================== -->
    <p class="bt1" style="margin-top: 30px;">4、用眼和饮食习惯相关:</p>
    <!-- InquiryTimeForShort: string 近距离用眼时长 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.每天看书写作业等近距离用眼有多长时间?</p>
        <p>了解近距离用眼量,评估双眼视功能和用眼需求是否匹配</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryTimeForShort" label="2小时以内">2小时以内</el-radio>
        <el-radio v-model="form.InquiryTimeForShort" label="2~4小时">2~4小时</el-radio>
        <el-radio v-model="form.InquiryTimeForShort" label="4小时以上">4小时以上</el-radio>
      </div>
    </div>
    <!-- InquiryTimeForOutdoor: string 户外活动时长 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.每天户外活动多长时间?</p>
        <p>了解户外活动时长是否充足,时间不足的要考虑用全光谱护眼灯补足</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryTimeForOutdoor" label="很少">很少</el-radio>
        <el-radio v-model="form.InquiryTimeForOutdoor" label="2小时以内">2小时以内</el-radio>
        <el-radio v-model="form.InquiryTimeForOutdoor" label="2小时以上">2小时以上</el-radio>
      </div>
    </div>
    <!-- InquiryTimeForSleep: string 睡眠时长 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.每天睡眠多长时间?</p>
        <p>了解休息是否充足,是否影响度数稳定</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryTimeForSleep" label="6小时以内">6小时以内</el-radio>
        <el-radio v-model="form.InquiryTimeForSleep" label="6~8小时">6~8小时</el-radio>
        <el-radio v-model="form.InquiryTimeForSleep" label="8小时以上">8小时以上</el-radio>
      </div>
    </div>
    <!-- InquiryShortViewProblem: [0/1] x9 近距离用眼问题 -->
    <div class="slxgbox">
      <div class="slxgbox-a" style="width: 100%;">
        <p>.阅读、写作业等近距离用眼是否有以下问题？</p>
        <p>了解是否有双眼视功能异常的相关症状,好针对性的检查和处理</p>
        <div style="display: flex;padding-top: 10px;flex-wrap: wrap;">
          <el-checkbox :value="!!form.InquiryShortViewProblem[0]" @input="(v) => $set(form.InquiryShortViewProblem, 0, v ? true : false)">速度慢</el-checkbox>
          <el-checkbox :value="!!form.InquiryShortViewProblem[1]" @input="(v) => $set(form.InquiryShortViewProblem, 1, v ? true : false)">丢字</el-checkbox>
          <el-checkbox :value="!!form.InquiryShortViewProblem[2]" @input="(v) => $set(form.InquiryShortViewProblem, 2, v ? true : false)">漏字</el-checkbox>
          <el-checkbox :value="!!form.InquiryShortViewProblem[3]" @input="(v) => $set(form.InquiryShortViewProblem, 3, v ? true : false)">重影串行</el-checkbox>
          <el-checkbox :value="!!form.InquiryShortViewProblem[4]" @input="(v) => $set(form.InquiryShortViewProblem, 4, v ? true : false)">注意力不集中</el-checkbox>
          <el-checkbox :value="!!form.InquiryShortViewProblem[5]" @input="(v) => $set(form.InquiryShortViewProblem, 5, v ? true : false)">犯困</el-checkbox>
          <el-checkbox :value="!!form.InquiryShortViewProblem[6]" @input="(v) => $set(form.InquiryShortViewProblem, 6, v ? true : false)">头疼</el-checkbox>
          <el-checkbox :value="!!form.InquiryShortViewProblem[7]" @input="(v) => $set(form.InquiryShortViewProblem, 7, v ? true : false)">易疲劳</el-checkbox>
          <el-checkbox :value="!!form.InquiryShortViewProblem[8]" @input="(v) => $set(form.InquiryShortViewProblem, 8, v ? true : false)">聚焦困难</el-checkbox>
        </div>
      </div>
    </div>
    <!-- InquiryChangeViewProblem: string 远近交替是否模糊 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.视线远近交替是否有模糊,反应速度慢</p>
        <p>了解是否有调节灵敏度的异常,好针对性的检查和处理</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryChangeViewProblem" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryChangeViewProblem" :label="false">否</el-radio>
      </div>
    </div>
    <!-- InquiryEyeHabit: string 用眼习惯（多选，逗号拼接） -->
    <div class="slxgbox">
      <div class="slxgbox-a" style="width: 100%;">
        <p>.是否有以下用眼习惯？</p>
        <p>了解是否有不良用眼习惯,用于评估用眼习惯和视力之间的相关影响</p>
        <div style="display: flex;padding-top: 10px;">
          <el-checkbox-group v-model="eyeHabitList">
            <el-checkbox label="眯眼"></el-checkbox>
            <el-checkbox label="歪头"></el-checkbox>
            <el-checkbox label="趴的近"></el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <!-- InquiryPickyEating: int 0/1 是否挑食 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.是否挑食？</p>
      </div>
      <div>
        <el-radio v-model="form.InquiryPickyEating" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryPickyEating" :label="false">否</el-radio>
      </div>
    </div>
    <!-- InquiryIsDessert: int 0/1 是否喜欢吃甜食 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.是否喜欢吃甜食？</p>
        <p>是否饮食问题导致近视或涨度数</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryIsDessert" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryIsDessert" :label="false">否</el-radio>
      </div>
    </div>

    <!-- ==================== 5、健康状况 ==================== -->
    <p class="bt1" style="margin-top: 30px;">5、健康状况:</p>
    <!-- InquiryALlergy: string 过敏史 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.是否有过敏史？</p>
        <p>了解对哪些过敏,给最终处方时要规避此影响</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryALlergy" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryALlergy" :label="false">否</el-radio>
      </div>
    </div>
    <!-- InquiryEyeDisease: string 眼病史 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.是否有眼病史？</p>
        <p>了解眼病史,矫正视力不良时,能全面考虑</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryEyeDisease" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryEyeDisease" :label="false">否</el-radio>
      </div>
    </div>
    <!-- InquiryFamilyEyeDisease: string 家人眼部问题（多选，逗号拼接） -->
    <div class="slxgbox">
      <div class="slxgbox-a" style="width: 100%;">
        <p>.家人是否有以下眼部问题</p>
        <p>了解是否有家族遗传史</p>
        <div style="display: flex;padding-top: 10px;">
          <el-checkbox-group v-model="familyEyeDiseaseList">
            <el-checkbox label="近视"></el-checkbox>
            <el-checkbox label="斜视"></el-checkbox>
            <el-checkbox label="弱视"></el-checkbox>
            <el-checkbox label="色觉异常"></el-checkbox>
            <el-checkbox label="无"></el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>

    <!-- ==================== 6、出生史相关 ==================== -->
    <p class="bt1" style="margin-top: 30px;">6、出生史相关:</p>
    <!-- InquiryPretermBirth: int 0/1 是否早产 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.出生时是否早产：</p>
        <p>跟弱视相关:早产更容易出现弱视</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryPretermBirth" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryPretermBirth" :label="false">否</el-radio>
      </div>
    </div>
    <!-- InquiryBornWeight: string 出生体重 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.出生体重：</p>
        <p>体重小更容易出现弱视,体重大容易形成近视</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryBornWeight" label="<5斤"><5斤</el-radio>
        <el-radio v-model="form.InquiryBornWeight" label="5~8斤">5~8斤</el-radio>
        <el-radio v-model="form.InquiryBornWeight" label="≥8斤">≥8斤</el-radio>
      </div>
    </div>
    <!-- InquiryBornJaundice: int 0/1 出生黄疸 -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.出生是否照过蓝光(黄疸值高)：</p>
        <p>照蓝光可能会损伤眼底</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryBornJaundice" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryBornJaundice" :label="false">否</el-radio>
      </div>
    </div>
    <!-- InquiryOxygenInhalation: int 0/1 是否吸氧 + InquiryOxygenInhalation_Des: string -->
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.是否有吸氧史?</p>
        <p>会引发视网膜病变,永久性损伤视力</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryOxygenInhalation" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryOxygenInhalation" :label="false">否</el-radio>
        <span>吸氧浓度和持续时长</span>
        <input style="width: 150px;padding-left: 10px;margin-top: 10px;" type="text" v-model="form.InquiryOxygenInhalation_Des">
      </div>
    </div>

    <!-- InquiryRemark: string 备注 -->
    <div class="qitsq" style="padding-top: 20px;">
      <p>备注:</p>
      <input type="text" v-model="form.InquiryRemark">
    </div>

    <div style="padding-top: 20px;">
      <el-button type="primary" @click="handleSave">保存</el-button>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios"
import publicFn from '@/publicFn/baseFn'

export default {
  name: "bsdwz",
  data() {
    return {
      // 主表单数据，字段类型与后端完全一致
      form: {
        InquiryChooseId: "",
        InquiryEditTime: "",
        // 1、主诉 [bool] x9
        InquiryIntention: [false, false, false, false, false, false, false, false, false],
        InquiryIntentionDes: "",
        // 2、视力/视觉相关
        InquiryVisualMonth: "",
        InquiryLastEyeCheck: "",
        InquiryEyeFullCheck: false,
        InquiryBSDFile: false,
        InquiryEyeTrain: false,
        InquiryAtropine: false,
        InquiryPEProblem: false,
        // 3、旧镜史相关
        InquiryCorrection: [false, false, false, false, false],
        InquiryOtherCorrection: "",
        InquiryFormerLensType: "",
        InquiryFormerLensClear: "",
        InquiryFormerLensComfortable: "",
        InquiryFormerLensFrequency: "",
        InquiryFormerLensStatus: "",
        InquiryChangeGlasses: "",
        InquiryChangeGlassesDegree: "",
        InquiryIsFrameGlasses: "",
        // 4、用眼和饮食习惯相关
        InquiryTimeForShort: "",
        InquiryTimeForOutdoor: "",
        InquiryTimeForSleep: "",
        InquiryShortViewProblem: [false, false, false, false, false, false, false, false, false],
        InquiryChangeViewProblem: "",
        InquiryEyeHabit: "",
        InquiryPickyEating: false,
        InquiryIsDessert: false,
        // 5、健康状况
        InquiryALlergy: false,
        InquiryEyeDisease: false,
        InquiryFamilyEyeDisease: "",
        // 6、出生史相关
        InquiryPretermBirth: false,
        InquiryBornWeight: "",
        InquiryBornJaundice: false,
        InquiryOxygenInhalation: false,
        InquiryOxygenInhalation_Des: "",
        // 备注
        InquiryRemark: ""
      },
      // 辅助字段：最近检查时间拆分
      lastEyeCheckYear: "",
      lastEyeCheckMonth: "",
      noEyeCheck: false,
      // 辅助字段：用眼习惯多选 → 拼成字符串给 InquiryEyeHabit
      eyeHabitList: [],
      // 辅助字段：家人眼部问题多选 → 拼成字符串给 InquiryFamilyEyeDisease
      familyEyeDiseaseList: []
    }
  },
  created() {
    // console.log(this._getUrl('InquiryBSDChildren_Get'))
    const log = this.$loading({
      text: '加载中...'
    })
    axios.post(this._getUrl('InquiryBSDChildren_Get'), {
      "token": {
        "TimeSpan": 1724754569,
        "sToken": "8D6BB1DF4BDAB60B6F3B46A77D9A4530"
      },
      "SearchCondition": {
        "ChooseId": this.$store.state.physicianVisits.xzConsulting,
      }
    }).then(res => {
      log.close()
      if (res.Result) {
        const data = res.Result
        // 后端返回 0/1 → bool
        // console.log(res)
        const bools = ['InquiryEyeFullCheck','InquiryBSDFile','InquiryEyeTrain','InquiryAtropine','InquiryPEProblem','InquiryPickyEating','InquiryIsDessert','InquiryPretermBirth','InquiryBornJaundice','InquiryOxygenInhalation']
        const arrs = ['InquiryIntention','InquiryCorrection','InquiryShortViewProblem']
        bools.forEach(k => { if (k in data) data[k] = !!data[k] })
        arrs.forEach(k => { if (Array.isArray(data[k])) data[k] = data[k].map(v => !!v) })
        this.form = data
        // 回填拼接字段
        if (this.form.InquiryLastEyeCheck) {
          const parts = this.form.InquiryLastEyeCheck.split('、')
          this.lastEyeCheckYear = parts[0] || ''
          this.lastEyeCheckMonth = parts[1] || ''
        }
        if (this.form.InquiryEyeHabit) {
          this.eyeHabitList = this.form.InquiryEyeHabit.split(',').filter(Boolean)
        }
        if (this.form.InquiryFamilyEyeDisease) {
          this.familyEyeDiseaseList = this.form.InquiryFamilyEyeDisease.split(',').filter(Boolean)
        }
      }
    })
  },
  watch: {
    lastEyeCheckYear: { handler: "buildLastEyeCheck" },
    lastEyeCheckMonth: { handler: "buildLastEyeCheck" },
    noEyeCheck(val) {
      if (val) {
        this.lastEyeCheckYear = ""
        this.lastEyeCheckMonth = ""
        this.form.InquiryLastEyeCheck = "没有检查过视力"
      } else {
        this.buildLastEyeCheck()
      }
    },
    eyeHabitList: {
      handler(val) { this.form.InquiryEyeHabit = val.join(",") },
      deep: true
    },
    familyEyeDiseaseList: {
      handler(val) { this.form.InquiryFamilyEyeDisease = val.join(",") },
      deep: true
    }
  },
  methods: {
    // 拼接最近检查时间
    buildLastEyeCheck() {
      if (this.noEyeCheck) return
      const y = this.lastEyeCheckYear
      const m = this.lastEyeCheckMonth
      this.form.InquiryLastEyeCheck = (y || m) ? `${y || ""}、${m || ""}` : ""
    },

    // 构建保存用的数据（bool → 0/1）
    buildSaveData() {
      return {
        InquiryChooseId: this.$store.state.physicianVisits.xzConsulting,
        InquiryEditTime: this.form.InquiryEditTime,
        InquiryIntention: this.form.InquiryIntention,
        InquiryIntentionDes: this.form.InquiryIntentionDes,
        InquiryVisualMonth: this.form.InquiryVisualMonth,
        InquiryLastEyeCheck: this.form.InquiryLastEyeCheck,
        InquiryEyeFullCheck:this.form.InquiryEyeFullCheck,
        InquiryBSDFile: this.form.InquiryBSDFile,
        InquiryEyeTrain: this.form.InquiryEyeTrain,
        InquiryAtropine: this.form.InquiryAtropine,
        InquiryPEProblem: this.form.InquiryPEProblem,
        InquiryCorrection: this.form.InquiryCorrection,
        InquiryOtherCorrection: this.form.InquiryOtherCorrection,
        InquiryFormerLensType: this.form.InquiryFormerLensType,
        InquiryFormerLensClear: this.form.InquiryFormerLensClear,
        InquiryFormerLensComfortable: this.form.InquiryFormerLensComfortable,
        InquiryFormerLensFrequency: this.form.InquiryFormerLensFrequency,
        InquiryFormerLensStatus: this.form.InquiryFormerLensStatus,
        InquiryChangeGlasses: this.form.InquiryChangeGlasses,
        InquiryChangeGlassesDegree: this.form.InquiryChangeGlassesDegree,
        InquiryIsFrameGlasses: this.form.InquiryIsFrameGlasses,
        InquiryTimeForShort: this.form.InquiryTimeForShort,
        InquiryTimeForOutdoor: this.form.InquiryTimeForOutdoor,
        InquiryTimeForSleep: this.form.InquiryTimeForSleep,
        InquiryShortViewProblem: this.form.InquiryShortViewProblem,
        InquiryChangeViewProblem: this.form.InquiryChangeViewProblem,
        InquiryEyeHabit: this.form.InquiryEyeHabit,
        InquiryPickyEating: this.form.InquiryPickyEating,
        InquiryIsDessert: this.form.InquiryIsDessert,
        InquiryALlergy: this.form.InquiryALlergy,
        InquiryEyeDisease_Des: this.form.InquiryEyeDisease_Des,
        InquiryFamilyEyeDisease: this.form.InquiryFamilyEyeDisease,
        InquiryPretermBirth: this.form.InquiryPretermBirth,
        InquiryBornWeight: this.form.InquiryBornWeight,
        InquiryBornJaundice: this.form.InquiryBornJaundice,
        InquiryOxygenInhalation: this.form.InquiryOxygenInhalation,
        InquiryOxygenInhalation_Des: this.form.InquiryOxygenInhalation_Des,
        InquiryRemark: this.form.InquiryRemark
      }
    },

    // 保存
    handleSave() {
      const o = this.buildSaveData()

      // console.log(o)
      // return

      const log = this.$loading({
        text: '保存中...'
      })
      axios.post(this._getUrl('InquiryBSDChildren_Update'), {
        token: {
          TimeSpan: 1566827733,
          sToken: "768DCAFFF869CD61372790C2738012EC"
        },
        o: o,
      }).then(res => {
        log.close()
        this.$alert(res.displaymsg)
      }).catch(err => {
        this.$message.error("保存失败，请稍后再试")
        console.error("bsdwz save error:", err)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.bsdwz {
  width: 90%;
  margin: 0 auto;
  padding-bottom: 20px;
}
.bt1 {
  text-align: left;
  padding: 5px 10px;
  background: #e5e5e5;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 20px;
}

.sjwt {
  display: flex;
  text-align: left;
  padding-bottom: 15px;
  p {
    width: 33%;
    span {
      display: block;
      font-size: 13px;
      color: #8eb2ff;
      padding-left: 25px;
    }
  }
}

.qitsq {
  display: flex;
  align-content: center;
  input {
    width: calc(100% - 150px);
    margin-left: 20px;
    border: none;
    border-bottom: 1px solid #000000;
  }
}

.slxgbox {
  display: flex;
  align-content: center;
  text-align: left;
  border-bottom: 1px dashed #818181;
  padding-bottom: 5px;
  margin-bottom: 10px;
  .slxgbox-a {
    width: 60%;
    p{color: #8eb2ff;font-size: 14px;}
    p:nth-child(1) {color: #000000;}
  }
  input {
    width: 50px;
    border: none;
    border-bottom: 1px solid #000000;
    text-align: center;
  }
}
</style>
